<template>
    <div class="vuetable-filterbar col-md-12">
	    <div class="form-group p-l">
            <b-container fluid class="p-a-0">
                <b-row no-gutters>
                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="num_doc" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Nº Doc</label>
                        </div>
                    </b-col>

                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <multiselect v-model="modal"
                        :options="optionsModal"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Modal"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>

                    <b-col sm="6" md="2" class="m-t-5px">
                        <div class="input-group-btn">
                          <div class="btn-group">
                            <button type="button" class="btn btn-secondary btn-outline" @click="doFilter" :disabled="vuetableFilterButton">Filtrar</button>
                            <button type="button" class="btn btn-secondary btn-outline" @click="resetFilter" :disabled="vuetableFilterButton">Limpar</button>
                          </div>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
	     </div>
     </div>
</template>

<script>
export default {
  data () {
    return {
      num_doc: '',
      optionsModal: [],
      modal: [],
      data_filter: [],
      helpForm: new Form({statusRecord: [], params: []}),

    }
  },
  mounted() {
      this.getModal();
    },
  methods: {
      doFilter () {
          this.$store.commit('setVuetableFilterButton', true);
          this.data_filter = {num_doc: this.num_doc,
                              modal: this.modal}
          this.$events.fire('filter-set', this.data_filter);
      },
      resetFilter () {
        this.num_doc = '';  // clear the text in text input
        this.modal = '';
        this.$events.fire('filter-reset');
      },
      getModal() {
          this.helpForm.params = { tabela: 'doc_transp',
                                  coluna: 'modal' };

          this.helpForm.get('/api/listitemvalor/jsonlist').then(response =>
          {
              new ReturnApi(response, this, true, false, false);
              response.items.forEach((obj)=>
              {
                  this.optionsModal.push({ label: obj.descr, value: obj.valor })
              })
          })
          .catch(errors =>
          {
              new ReturnApi(errors, this)
          });
      }
   },
   computed: {
       vuetableFilterButton: {
           get () {
               return this.$store.state.vuetable.filterButton;
           },
       },
   }
 }
</script>
